import {
    appendData,
    collectFormData,
    sendData,
    sendReceiveData,
    sendEvent,
    transformData,
    collectGIWLFormData,
    sendDataAsync,
} from "../collector";
import $ from "jquery";
import { checkAndSetEmailSource } from "../utils/data-source-code";
import { ageLastBirthday, createDate } from "../utils/age";
import { getCombinedValidationData, getQuoteResultsData } from "./aaalife-utils-get-data";
import { browserStorage } from "./aaalife-utils-browser-storage";
import { getClubAndCampaignProfile, updateDynamicPhone } from "../utils/aaalife-dynamic-phone";
import { retrieveUrlParameters } from "../utils/page";

export function initQuoteForm() {
    // disable "this" error validation - jQuery event handlers use "this" for
    // the DOM element
    /* jshint validthis:true */

    var _quoterValid = {
        panel1: {
            zip: false,
            gender: false,
            age: false,
            isMember: false,
            emailFormat: false,
            policyReplacement: false,
        },
        panel1Fields: {
            zipField: $(".zipNumeric"),
            genderField: $("#gender"),
            ageField: $("#quoteForm .date select"),
            isMemberField: $('[name="isMember"]'),
            emailFormatField: $("#contact_email"),
            policyReplacementField: $('[name="policy_type"]'),
        },
        panel1Error: {
            zipError: $("#zipLabel"),
            genderError: $("#genderLabel"),
            ageError: $("#DOBLabel"),
            isMemberError: $("#aaaMemberLabel"),
            emailFormatError: $("#emailLabel"),
        },
        panel2: {
            typeChosen: false,
        },
        panel2Fields: {
            typeChosenField: $('[name="insurance_type"]'),
        },
        panel2Error: {
            typeChosenError: $("#insurance_typeLabel"),
        },
        panel3: {
            existingPolicy: true,
            validBMI: false,
            height: false,
            weight: false,
            usedNicotine: false,
            rateYourHealth: false,
            coverageAmount: false,
            termLength: false,
        },
        panel3Fields: {
            existingPolicyField: $('[name="policy_type"]'),
            validBMIField: $(".bmi select, .bmi input"),
            heightField: $(".bmi select"),
            weightField: $(".bmi input"),
            usedNicotineField: $('[name="nicotineUse"]'),
            rateYourHealthField: $('[name="rateYourHealth"]'),
            coverageAmountField: $("#coverageAmount"),
            termLengthField: $("#termLength"),
        },
        panel3Error: {
            existingPolicyError: $("#existingPolicyLabel"),
            validBMIError: $("#heightLabel, #weightLabel"),
            heightError: $("#heightLabel"),
            weightError: $("#weightLabel"),
            usedNicotineError: $("#nicotineLabel"),
            rateYourHealthError: $("#healthConditionLabel"),
            coverageAmountError: $("#coverageAmountLabel"),
            termLengthError: $("#termLengthLabel"),
        },
    };

    var errorFieldValidation = {
        NYStateError: false,
        stateError: false,
        existingPolicy: false,
    };

    var _zipRestrictions = {};
    var _inlineModal;
    var _disallowThirty = false;

    if ($("#quoteForm").length > 0 || $("#expressTermForm").length > 0) {
        init();
    }

    if ($("#combinedQuote-productSelection").length > 0) {
        _initQuoteFormButtons();
    }

    if ($('form[name="combinedQuoteForm"]').length > 0) {
        _initCombinedQuoteForm();
    }

    function _getUserData() {
        var user = browserStorage.getObject("user");
        if (!user) {
            user = aaalife.data.user || {};
        }
        return user;
    }

    function _getQuoteData() {
        var quote = browserStorage.getObject("quote");
        if (!quote) {
            quote = aaalife.data.quote || {};
        }
        return quote;
    }

    /**
     * init
     */
    function init() {
        var formReady = false;
        var validationData = getCombinedValidationData(true);
        // TODO: this is only needed if we can actually extrapolate the proper
        // data from it
        var quoteResultsData = getQuoteResultsData();

        Promise.all([quoteResultsData, validationData]).then(([resultsData, validationData]) => {
            _initializeQuoteForm(validationData);

            // Combined Quote functions
            if ($(".qfWide").length > 0) {
                _initializeCombinedQuote();
            }
        });

        // Reset quote type so that the user can choose it again, unless the
        // server has specifically set it or if on the single quote wide form
        if ($(".qfWide").length === 0) {
            aaalife.data.quote.type = aaalife.fromServer.quoteType || "";
        }
        // or maybe it has already been selected on the wide interstitial page?
        var quote = _getQuoteData();
        aaalife.data.quote = quote;
        aaalife.data.quote.type =
            (browserStorage.getObject("quote") && browserStorage.getObject("quote").type) || aaalife.data.quote.type;

        _initQuoteFormButtons();

        /**
         * _initializeQuoteForm
         *
         * @param data
         * @private
         */
        function _initializeQuoteForm(data) {
            formReady = true;

            _populateDropdowns($(".inc"), 0, 11, 1);
            _populateDropdowns(
                $("#year"),
                new Date().getFullYear() - data.restrictions.dropdownAges.minAge,
                new Date().getFullYear() - data.restrictions.dropdownAges.maxAge,
                -1,
            );
            _populateDropdowns(
                $("#needs_year"),
                new Date().getFullYear() - data.restrictions.dropdownAges.minAge,
                new Date().getFullYear() - data.restrictions.dropdownAges.maxAge,
                -1,
            );

            _populateDaysDropdown();

            _initEventListeners();
            _populateUserValuesIfSaved();
            //Call to zip validation to display error message if geolocator zip is invalid
            zipReturnState();

            $("input, select").addClass("pristine").on("focus blur", _markDirty);

            if ($('form[name="panelsQuoteFormTraditional"]').length > 0) {
                _setInsuranceTypeToTraditional();
            } else if (
                $('form[name="panelsQuoteFormExpress"]').length > 0 ||
                $('form[name="expressTermCampaign"]').length > 0
            ) {
                _setInsuranceTypeToExpress();
            }

            _panelSlide();
        }

        // Hide error text
        _showInlineError(false);
        aaalife.utils.modalInit();
        _inlineModal = new aaalife.utils.Inline({
            content: $(".errorModal"),
        });
    }

    function _initQuoteFormButtons() {
        $(".get-express-quote-button, .get-traditional-quote-button").on("click", _getQuoteClicked);
        $(".combinedForm-backBtn").on("click", _combinedFormBackClicked);
    }

    function _initCombinedQuoteForm() {
        var topOfFormPanel;
        var quote = _getQuoteData();
        aaalife.data.quote.estimatedNeed = quote.estimatedNeed;

        if (quote.type == "") {
            quote.type = "traditional_term";
            _setInsuranceTypeToTraditional();
        }

        if ($("#combinedQuoteFormTraditionalOnly").length > 0) {
            _setInsuranceTypeToTraditional();
        }

        if ($("#combinedQuoteFormExpressOnly").length > 0) {
            _setInsuranceTypeToExpress();
        }

        _setCoverageAndTermOptions(quote.type, true);

        // scroll to the top of the form, if needed
        topOfFormPanel = $(".combinedForm-quoteForm .formCmpnt-form").offset().top;
        if (window.scrollY > topOfFormPanel) {
            window.scrollTo(0, topOfFormPanel);
        }

        _setDisplayBasedOnInsuranceType();
    }

    function zipReturnState(e) {
        var geocoder = new google.maps.Geocoder();
        var $zip = $("#zip");
        var zip = $zip.val();

        if (zip) {
            geocoder.geocode(
                {
                    componentRestrictions: {
                        country: "US",
                        postalCode: zip,
                    },
                },
                _processGeocodeResults,
            );
        }

        function _processGeocodeResults(results, status) {
            var user = _getUserData();

            if (status !== google.maps.GeocoderStatus.OK) {
                console.warn("Geocode failed for zip code " + zip);
            }

            function getComponentShortName(componentNames, components) {
                return components
                    .filter(function (c) {
                        return componentNames.reduce(function (accumulator, currentValue) {
                            return accumulator && c.types.includes(currentValue);
                        }, true);
                    })
                    .map(function (c) {
                        return c.short_name;
                    })
                    .find(function (name) {
                        return name;
                    });
            }

            const location =
                results
                    .map(function (result) {
                        return {
                            state: getComponentShortName(["administrative_area_level_1"], result.address_components),
                            city: getComponentShortName(["locality", "political"], result.address_components),
                            zip: getComponentShortName(["postal_code"], result.address_components),
                        };
                    })
                    // Ensure we have a state and zip at least
                    .find(function (location) {
                        return location.state && location.zip;
                    }) || {};

            // Mutate the current user object
            user.state = location.state;
            user.city = location.city;
            user.zip = location.zip;

            // Set some global state
            aaalife.data.user = user;
            browserStorage.setObject("user", aaalife.data.user);
        }
    }

    function _searchAddrComponents(addrComp) {
        return addrComp.types.find(_searchTypes);
    }

    function _searchTypes(type) {
        return type === "administrative_area_level_1";
    }
    // Event Handlers
    // -------------------------------------------------------------

    /**
     * _initEventListeners
     *
     * @private
     */
    function _initEventListeners() {
        // Validation Functionality Shared Between Expressterm and Term-Quote Campaigns
        $("#contact_email").on("change", _validateEmail);
        $("#year").on("change", _populateDaysDropdown);
        $("#month").on("change", _populateDaysDropdown);

        // Validation Functionality for Term-Quote Only
        if ($("#quoteForm").length > 0) {
            $(".panel-container-backbtn").on("click", _backClicked);
            $(".panel-container-nextbtn").on("click", _nextClicked);
            $("#giwl-panel1-next").on("click", _nextGIWLClicked);
            $("#giwl-panel2-enroll-now").on("click", _enrollNowGIWLClicked);
            $("#seeQuote").on("click", _seeQuoteClicked);
            /* ==MEMBERSHIP TOOLTIP POP UP ON CLICK QUESTION MARK== */
            $(".showtooltip svg").on("click", function () {
                $(this).parent().find(".tooltipinfo").show();
            });
            $(".tooltipinfo .tooltipclose").on("click", function () {
                $(this).parent().hide();
            });
            $('[name="zip"]').on("blur", _validateZip);
            $('[name="zip"]').on("blur", zipReturnState);
            $('[name="isMember"]').on("change", _validateIsMember);
            $("#contact_email").on("change", _validateEmail);
            $("#gender").on("change", _validateGender);
            $("#year").on("change", _validateAge);
            $("#day").on("change", _validateAge);
            $("#month").on("change", _validateAge);
            $('[name="insurance_type"]').on("change", _validateTypeChosen);
            $('[name="coverageAmount"]').on("change", _validateCoverageAmountOrTerm);
            $('[name="termLength"]').on("change", _validateCoverageAmountOrTerm);
        }
    }

    // Wide Quoter page
    // -----------------------------------------------------------

    /**
     * _initializeCombinedQuote
     *
     * @private
     */
    function _initializeCombinedQuote() {
        var quote = _getQuoteData();
        aaalife.data.quote.estimatedNeed = quote.estimatedNeed;

        if (aaalife.fromServer.productSelectSkipped === "true") {
            quote.type = aaalife.fromServer.quoteType;
        }

        _setupWideQuoter();
    }

    /**
     * _getQuoteClicked
     *
     * @param e
     * @private
     */
    function _getQuoteClicked(e) {
        var quote = _getQuoteData();
        var topOfFormPanel;

        if ($(e.target).hasClass("get-express-quote-button")) {
            quote.type = "express_term";
        } else if ($(e.target).hasClass("get-traditional-quote-button")) {
            quote.type = "traditional_term";
        } else {
            quote.type = "";
        }
        $('[value="' + quote.type + '"]').click();

        aaalife.data.quote = quote;
        browserStorage.setObject("quote", aaalife.data.quote);

        var data = transformData("insurance_type", quote.type);
        var groupData = transformData("current", data);
        sendData(groupData, false);
        window.location = aaalife.fromServer.urlStrings.inputPage;
    }

    /**
     * _combinedFormBackClicked
     *
     * @param e
     * @private
     */
    function _combinedFormBackClicked(e) {
        var quote = _getQuoteData();

        e.preventDefault();

        aaalife.data.quote = quote;
        browserStorage.setObject("quote", quote);

        window.location = aaalife.fromServer.urlStrings.productSelectionPage;
    }

    /**
     * _setupWideQuoter
     *
     * @private
     */
    function _setupWideQuoter() {
        var insurance_type = "";
        var quote = browserStorage.getObject("quote") || {};
        $(".panel-panel1.hide").removeClass("hide");
        $(".panel-panel3.hide").removeClass("hide");

        if (quote.type) {
            insurance_type = aaalife.data.quote.type;
        } else {
            insurance_type = "traditional_term";
        }

        if ($("#combinedQuoteFormTraditionalOnly").length > 0) {
            insurance_type = "traditional_term";
            quote.type = insurance_type;
            browserStorage.setObject("quote", quote);
            $('[value="traditional_term"]').click();
        }

        _setCoverageAndTermOptions(insurance_type, true);
        _setDisplayBasedOnInsuranceType();
    }

    function _setDisplayBasedOnInsuranceType() {
        var quote = _getQuoteData();
        var $productNameField = $(".productName-large");
        var $productNameMobileField = $(".productName-mobile");
        var $productDescriptionField = $(".productDescription");

        if (quote.type == "express_term") {
            $productNameField.text(aaalife.fromServer.expressTerm.title);
            $productNameMobileField.text(aaalife.fromServer.expressTerm.title);
            $productDescriptionField.text(aaalife.fromServer.expressTerm.content);
        } else {
            $productNameField.text(aaalife.fromServer.traditionalTerm.title);
            $productNameMobileField.text(aaalife.fromServer.traditionalTerm.title);
            $productDescriptionField.text(aaalife.fromServer.traditionalTerm.content);
        }
    }

    // Data - Get and Save
    // --------------------------------------------------------

    /**
     * _getUserData
     *
     * @returns {?Object}
     * @private
     */
    function _getUserData() {
        var user = browserStorage.getObject("user");

        if (!user) {
            user = aaalife.data.user || {};
        }
        return user;
    }

    /**
     * _getQuoteData
     *
     * @returns {?Object}
     * @private
     */
    function _getQuoteData() {
        var quote = browserStorage.getObject("quote");

        if (!quote) {
            quote = aaalife.data.quote || {};
        }
        return quote;
    }

    /**
     * _saveValues
     *
     * @private
     */
    function _saveValues() {
        var user = _getUserData();
        var quote = _getQuoteData();

        user.zip = $("#zip").val() || user.zip;

        user.gender = $("#gender").val() || user.gender;
        user.dobMonth = $("#month").val() || user.dobMonth;
        user.dobDay = $("#day").val() || user.dobDay;
        user.dobYear = $("#year").val() || user.dobYear;

        user.isMember = $("input:radio[name=isMember]:checked").val() || user.isMember;

        user.email = $("#contact_email").val() || user.email;

        user.hasPolicy = $("input:radio[name=policy_type]:checked").val() || user.hasPolicy;

        user.heightFeet = $("#feet").val() || user.heightFeet;
        user.heightInches = $("#inches").val() || user.heightInches;
        user.weight = $(".weightNumeric").val() || user.weight;

        user.health = $("#rateYourHealth").val() || user.health;
        user.nicotine = $("input:radio[name=nicotineUse]:checked").val() || user.nicotine;

        quote.coverage = $("#coverageAmount").val() || quote.coverage;
        quote.term = $("#termLength").val() || quote.term;
        quote.type = $("input[name=insurance_type]:checked").val() || quote.type;

        if ($(".combinedForm-quoteForm").length > 0) var evt = "TQLKO";
        // Event for combined forms
        else var evt = "TQSKO1"; // Event for panel forms

        // set _quoterValid with overall validity
        var ageValidation = aaalife.utils.validate.age(user.dobMonth, user.dobDay, user.dobYear);
        _quoterValid.panel1.age = ageValidation.valid;

        if (!ageValidation.valid) sendEvent(evt);

        aaalife.data.user = user;
        browserStorage.setObject("user", user);

        // Trigger custom event so the geolocation can update if needed
        if (!aaalife.fromServer.urlStrings.isCampaignPage) {
            $(document).trigger("userZipChanged");
        }

        aaalife.data.quote = quote;
        browserStorage.setObject("quote", quote);
    }

    // Data validation
    // ------------------------------------------------------------

    function replacementPolicyValidation() {
        //Check visibility - if not visible do nothing
        //Validate whether there are anything checked -- highlight if non checked
        //Validate whether yes has been checked -- highlight if checked

        if ($(".replaceExistingPolicy").hasClass("hide")) {
            $('[name="policy_type"]').attr("required", false);
        } else {
            //$('[name="policy_type"]').prop('required');
            $('[name="policy_type"]').attr("required", true);
        }
    }

    /**
     * _validatePanel
     *
     * @param panelToCheck
     * @returns {Object}
     * @private
     */
    function _validatePanel(panelToCheck) {
        var currentPanel = panelToCheck || _currentSlideIndex();

        if (currentPanel === 0) {
            if (!aaalife.utils.prevalidate.hasValidZip(_getUserData().zip)) {
                _applyKnockOut("y", false);
            }
            _validateGender.call($("#gender")[0], null, true);

            var day = $("#day").val();
            var month = $("#month").val();
            var year = $("#year").val();
            var ageValidation = aaalife.utils.validate.age(month, day, year);

            var ageInfo = {
                day: day,
                month: month,
                year: year,
                age: ageValidation,
            };

            if (!aaalife.utils.prevalidate.hasValidAge(ageInfo)) {
                _applyKnockOut("y", false);
            }
            _quoterValid.panel1.isMember = _validateIsMember.call($('[name="isMember"]:checked:first')[0]);
            _validateEmail.call($("#contact_email")[0]);
            _quoterValid.panel1.policyReplacement = true;
            $("#noExistingPolicy").removeClass("invalid");
            $("#yesExistingPolicy").removeClass("invalid");

            if (!$(".replaceExistingPolicy").hasClass("hide")) {
                if ($("#noExistingPolicy").prop("checked")) {
                    _quoterValid.panel1.policyReplacement = true;
                } else {
                    _quoterValid.panel1.policyReplacement = false;
                }
            }
        } else if (currentPanel === 1) {
            _validateTypeChosen.call($('[name="insurance_type"]:checked:first')[0]);
        }

        return _quoterValid;
    }

    /**
     * _allPanelsValid
     *
     * @returns {boolean}
     * @private
     */
    function _allPanelsValid() {
        var i;
        var numPanels = 3;
        var isValid = false;

        for (i = 1; i <= numPanels; i++) {
            isValid = _checkQuoterPanelValidity(_quoterValid["panel" + i]);
            if (!isValid) {
                break;
            }
        }

        return isValid;
    }

    /**
     * _checkQuoterPanelValidity
     *
     * @param panel
     * @returns {boolean}
     * @private
     */

    function _checkQuoterPanelValidity(panel) {
        return Object.keys(panel).every(_checkQuoterValidValue);

        /**
         * _checkQuoterValidValue
         *
         * @param key
         * @returns {*}
         * @private
         */
        function _checkQuoterValidValue(key) {
            return panel[key];
        }
    }

    /**
     * _validateCoverageAmountOrTerm
     *
     * @returns {boolean}
     * @private
     */
    function _validateCoverageAmountOrTerm() {
        var coverageOrTerm = this.id === "coverageAmount" ? "coverage" : "term";
        var newVal = $(this).val();
        var isValid = !!newVal;

        if (isValid) {
            aaalife.data.quote[coverageOrTerm] = newVal;
            browserStorage.setObject("quote", aaalife.data.quote);
            _highlightInvalidField(true, $(this));
        }

        return isValid;
    }

    /**
     * _hasValue
     *
     * @returns {boolean}
     * @private
     */
    function _hasValue() {
        var isRadioOrCheckbox =
            this instanceof jQuery && (this.eq(0).attr("type") === "radio" || this.eq(0).attr("type") === "checkbox");
        var $el = $(this);
        var isValid = $el.is(":visible") ? !aaalife.utils.validate.missingValue($el) : true;
        var id = $el[0] && $el[0].id;
        var i;
        var numPanels = 3;

        if (!isRadioOrCheckbox && $el[0]) {
            for (i = 1; i <= numPanels; i++) {
                if (typeof _quoterValid["panel" + i][id] !== "undefined") {
                    _quoterValid["panel" + i][id] = isValid;
                }
            }
        } else if (isRadioOrCheckbox) {
            isValid = !!this.filter(":checked").val();
        } else {
            isValid = false;
        }
        _highlightInvalidField(true, $el);

        return isValid;
    }

    // Panel 1

    /**
     * _validateZip
     *
     * @param e
     * @returns {boolean|*}
     * @private
     */
    function _validateZip(e) {
        var validData;
        var $zip = $("#zip");
        var zip = $zip.val();
        var valueMissing = aaalife.utils.validate.missingValue($zip);
        var validZip = aaalife.utils.validate.zipFormat(zip);
        var $allFields = $("#quoteForm input, #quoteForm select, #quoteForm button");

        if (e && (e.which < 48 || e.which > 57)) {
            e.preventDefault();
        }

        zip = $zip.val(zip.replace(/[^\d\-].+/, "")).val();
        validData = !valueMissing && validZip;
        _quoterValid.panel1.zip = validData;
        _highlightInvalidField(true, $zip);

        aaalife.utils.validate.zip(zip).then(_zipValidationComplete, _zipValidationError);

        return validData;
    }

    function _showInvalidFieldError(isValid, $argElement) {
        var $element = typeof $argElement !== "undefined" ? $argElement : $(this);

        if (isValid) {
            _showInlineError(false);
            $element.removeClass("show").addClass("hide");
        } else {
            if ($("#quoteForm").length > 0) {
                _showInlineErrorForQuoteForm(true);
            } else {
                _showInlineError(true);
            }
            $element.removeClass("hide").addClass("show");
        }
    }

    const giwlinValidStates = ["NY"];
    const giwlReplacementNotOffered = ["MI", "FL", "GA", "NV", "WY"];

    function isStateValid(state, blackList) {
        return blackList.includes(state);
    }

    var giwlCoverageOptions;
    (function ($, undefined) {
        $(document).ready(function () {
            $("div.showIfYesReplace").hide();
            $("input[name$='policy_type']").on("change", function () {
                validateReplacementPolicy();
            });
            $("#panel2-back").on("click", function () {
                $(".displayCovOpts").empty();
                $("h3.imgFormCmpnt-heading").text(quoteEntryTitle);
            });
        });
    })(jQuery);

    /**
     * _zipValidationComplete
     *
     * @param data
     * @private
     */
    function _zipValidationComplete(data) {
        var expressInvalid;
        var $allFields = $("#quoteForm input, #quoteForm select, #quoteForm button");

        _zipRestrictions = data;

        //Overriding the allTermNotOffered field since the value set in the field would be based on an incorrect list of states
        _zipRestrictions.allTermNotOffered = isStateValid(aaalife.data.user.state, giwlinValidStates);

        var itc = $("#quoteForm").data("panel-two");
        var source = $("#quoteForm").data("source-prime");
        aaalife.data.user.source = source;
        $("#giwl-panel1-next").data("itc", itc);
        $("#giwl-panel1-next").data("source", source);

        $("#panel3-back").data("itc", itc);
        $("#panel3-back").data("source", source);

        if (_zipRestrictions.allTermNotOffered) {
            _enableFields();
            _disableFieldsExceptZip();

            if ($("#quoteForm").length > 0) {
                _showInlineErrorForQuoteForm(true);
            } else {
                _showInlineError(true);
            }

            _showErrorModal(aaalife.fromServer.errorModalsData.expressTermNotOffered, true, _zipRestrictions.zip);
            _showInvalidFieldError(false, $("#stateError"));
            _quoterValid.panel1.zip = false;
            _applyKnockOut("y", false);
            sendEvent("GIWLKO2");
        } else {
            if ($allFields.not(".zipNumeric").attr("disabled")) {
                _enableFields();
            }

            _applyKnockOut("n", false);
        }

        if (_zipRestrictions.expressTermNotOffered) {
            aaalife.data.quote = browserStorage.getObject("quote") || {};

            if (typeof aaalife.fromServer.quoteType === "undefined") {
                if (aaalife.data.quote.type === "express_term") {
                    _handleExpressTermNotOffered_ExpressTerm(_zipRestrictions);
                } else {
                    _handleExpressTermNotOffered_TraditionalTerm(aaalife.data.quote);
                }
            } else {
                if (aaalife.fromServer.quoteType === "express_term") {
                    _handleExpressTermNotOffered_ExpressTerm(_zipRestrictions);
                } else {
                    _handleExpressTermNotOffered_TraditionalTerm(aaalife.data.quote);
                }
            }
        }

        if (isStateValid(aaalife.data.user.state, giwlReplacementNotOffered)) {
            $(".replaceExistingPolicy").removeClass("hide");
            replacementPolicyValidation();
        } else {
            $(".replaceExistingPolicy").addClass("hide");
            replacementPolicyValidation();
            $('[name="policy_type"]').prop("checked", false);
            _showInlineError(false);
            $("#noExistingPolicy").removeClass("invalid");
            $("#yesExistingPolicy").removeClass("invalid");
        }

        expressInvalid = _zipRestrictions.expressTermNotOffered && aaalife.data.quote.type === "express_term";
        _quoterValid.panel1.zip = _quoterValid.panel1.zip && !_zipRestrictions.allTermNotOffered && !expressInvalid;

        function _disableFieldsExceptZip() {
            var $zipField = $("#quoteForm input[name=zip]");

            $allFields.attr("disabled", "disabled");
            $zipField.removeAttr("disabled").addClass("invalid");
        }
        function _enableFields() {
            $allFields.removeAttr("disabled").removeClass("invalid");
        }

        function _handleExpressTermNotOffered_TraditionalTerm(quote) {
            if ($allFields.not(".zipNumeric").attr("disabled")) {
                _enableFields();
            }
            quote.type = "traditional_term";
            $('[value="' + quote.type + '"]').click();
            browserStorage.setObject("quote", quote);
            itc = $("#quoteForm").data("panel-three");
            source = $("#quoteForm").data("source-prime");
            aaalife.data.user.source = source;
            $("#giwl-panel1-next").data("itc", itc);
            $("#giwl-panel1-next").data("source", source);

            itc = $("#quoteForm").data("panel-one");
            $("#panel3-back").data("itc", itc);
            $("#panel3-back").data("source", source);
        }

        function _handleExpressTermNotOffered_ExpressTerm(_zipRestrictions) {
            _enableFields();
            _disableFieldsExceptZip();
            _showErrorModal(aaalife.fromServer.errorModalsData.expressTermNotOffered, true, _zipRestrictions.zip);
            _applyKnockOut("y", false);
            setKOValidation();
        }
    }

    function setKOValidation() {
        var evt = "TQSKO1";

        if ($(".combinedForm-quoteForm").length > 0) evt = "TQLKO"; // Event for combined forms

        sendEvent(evt);
    }

    function _zipValidationCompleteET(data) {
        var expressInvalid;
        var $allFields = $("#expressTermForm input, #expressTermForm select, #expressTermForm button");

        _zipRestrictions = data;
        _enableFields();

        var itc = $("#expressTermForm").data("panel-two");
        var source = $("#expressTermForm").data("source-prime");
        aaalife.data.user.source = source;
        $("#giwl-panel1-next").data("itc", itc);
        $("#giwl-panel1-next").data("source", source);

        $("#panel3-back").data("itc", itc);
        $("#panel3-back").data("source", source);

        if (_zipRestrictions.allTermNotOffered) {
            errorFieldValidation.NYStateError = true;
            _applyKnockOut("y", false);
            setKOValidation();
        } else {
            errorFieldValidation.NYStateError = false;
            _applyKnockOut("n", false);
        }

        if (_zipRestrictions.expressTermNotOffered) {
            aaalife.data.quote = browserStorage.getObject("quote") || {};
            errorFieldValidation.stateError = true;
            if (aaalife.data.quote.type == "express_term") {
                _applyKnockOut("y", false);
                setKOValidation();
            } else {
                aaalife.data.quote.type = "traditional_term";
                $('[value="' + aaalife.data.quote.type + '"]').click();
                browserStorage.setObject("quote", aaalife.data.quote);
                itc = $("#expressTermForm").data("panel-three");
                source = $("#expressTermForm").data("source-alt");
                aaalife.data.user.source = source;
                $("#giwl-panel1-next").data("itc", itc);
                $("#giwl-panel1-next").data("source", source);

                itc = $("#expressTermForm").data("panel-one");
                $("#panel3-back").data("itc", itc);
                $("#panel3-back").data("source", source);
            }
        } else {
            errorFieldValidation.stateError = false;
        }

        if (_zipRestrictions.replacementPolicyNotOffered) {
            $(".replaceExistingPolicy").removeClass("hide");
            errorFieldValidation.existingPolicy = true;
        } else {
            $(".replaceExistingPolicy").addClass("hide");
            errorFieldValidation.existingPolicy = false;
            $('[name="policy_type"]').prop("checked", false);
        }

        function _disableFieldsExceptZip() {
            var $zipField = $("#expressTermForm input[name=zip]");

            $allFields.attr("disabled", "disabled");
            $zipField.removeAttr("disabled").addClass("invalid");
        }
        function _enableFields() {
            $allFields.removeAttr("disabled").removeClass("invalid");
        }
    }

    /**
     * _zipValidationError
     *
     * @private
     */
    function _zipValidationError() {
        var validData;
        var $zip = $("#zip");

        validData = false;
        _quoterValid.panel1.zip = validData;
    }

    /**
     *
     * @param e
     * @param shouldValidate
     * @private
     */
    function _validateGender(e, shouldValidate) {
        var isValid = aaalife.utils.validate.gender($(this));

        if (shouldValidate) {
            _highlightInvalidField(isValid, $(this));
            _quoterValid.panel1.gender = isValid;
        } else {
            _highlightInvalidField(true, $(this));
        }
    }

    /**
     * _validateAge
     *
     * @param colorFlag
     * @private
     */
    function _validateAge(colorFlag) {
        var day = $("#day").val();
        var month = $("#month").val();
        var year = $("#year").val();
        var ageValidation = aaalife.utils.validate.age(month, day, year);
        const age = ageLastBirthday(createDate(year, month, day), new Date());
        var nicotine = $('[name="nicotineUse"]:checked:first').val();
        var minAgeYoung = 45;
        var maxAgeOld = 85;

        if ($(".combinedForm-quoteForm").length > 0) var evt = "TQLKO";
        // Event for combined forms
        else var evt = "GIWLKO1"; // Event for panel forms

        // set _quoterValid with overall validity
        _quoterValid.panel1.age = ageValidation.valid;

        var ageInfo = {
            day: day,
            month: month,
            year: year,
            age: age,
        };
        if (!aaalife.utils.prevalidate.hasValidAge(ageInfo)) {
            if (!ageValidation.valid && ageValidation.allSelected) {
                _applyKnockOut("y", false);
            } else if (ageValidation.valid) {
                _applyKnockOut("n", false);
            }
        }
        if (!day || !month || !year) {
            [$("#day"), $("#month"), $("#year")].forEach(function ($el) {
                if (!$el.val() && $el.hasClass("dirty") && colorFlag === "showRed") {
                    $el.removeClass("valid").addClass("invalid");
                    _quoterValid.panel1.age = false;
                } else if ($el.val() !== "") {
                    $el.removeClass("invalid").addClass("valid");
                    if (day !== "" && month !== "" && year !== "") {
                        _showInlineError(false);
                    }
                }
            });
        } else if (!ageValidation.valid) {
            if (age < minAgeYoung) {
                if (aaalife.fromServer.urlStrings.isCampaignPage) {
                    _showErrorModal(aaalife.fromServer.errorModalsData.ageGuidelinesNotMet);
                } else {
                    _showErrorModal(aaalife.fromServer.errorModalsData.ageGuidelinesNotMet, true, $("#zip").val());
                }
                _showInlineError(true);
                // highlight age with error condition
                $(".date select").removeClass("valid").addClass("invalid");

                sendEvent(evt);
            } else if (age > maxAgeOld) {
                if (aaalife.fromServer.urlStrings.isCampaignPage) {
                    _showErrorModal(aaalife.fromServer.errorModalsData.ageGuidelinesNotMetOld);
                } else {
                    _showErrorModal(aaalife.fromServer.errorModalsData.ageGuidelinesNotMetOld, true, $("#zip").val());
                }
                _showInlineError(true);

                // highlight age with error condition
                $(".date select").removeClass("valid").addClass("invalid");

                sendEvent(evt);
            }
        } else {
            [$("#day"), $("#month"), $("#year")].forEach(function ($el) {
                if (!$el.val() && $el.hasClass("dirty") && colorFlag === "showRed") {
                    $el.removeClass("valid").addClass("invalid");
                    _quoterValid.panel1.age = false;
                } else if ($el.val() !== "") {
                    $el.removeClass("invalid").addClass("valid");
                    if (day !== "" && month !== "" && year !== "") {
                        _showInlineError(false);
                    }
                }
            });
        }

        _disallowThirty = aaalife.utils.validate.ageNicotine(nicotine, age);

        // Update coverage amount and term length dropdowns if BMI info is
        // filled out
        _setCoverageAndTermOptions(aaalife.data.quote.type, true);
    }

    /**
     * _validateIsMember
     *
     * @returns {boolean}
     * @private
     */
    function _validateIsMember(e) {
        var isMemberValid = aaalife.utils.validate.validateIsMember($(this));

        _highlightInvalidField(isMemberValid, $('[name="isMember"]'));

        return isMemberValid;
    }

    function _validateReplacementPolicy(e) {
        var isReplacementPolicyValid = aaalife.utils.validate.validateExistingPolicy($(this));
        _highlightInvalidField(isReplacementPolicyValid, $('[name="policy_type"]'));
        return isReplacementPolicyValid;
    }
    /**
     * _validateEmail
     *
     * @private
     */
    function _validateEmail() {
        var isValid;
        var $input = $(this);
        var email = $input.val();

        isValid = aaalife.utils.validate.emailFormat(email);

        _quoterValid.panel1.emailFormat = isValid;

        if (isValid) {
            _showInlineError(false);
            $input.removeClass("invalid").addClass("valid");
            checkAndSetEmailSource(email);
        } else {
            _showInlineError(true);
            $input.removeClass("valid").addClass("invalid");
        }
    }

    // Panel 2 (Interstitial)

    /**
     * _validateTypeChosen
     *
     * @private
     */
    function _validateTypeChosen() {
        var isValid;
        var $inputs = $('[name="insurance_type"]');

        isValid = aaalife.utils.validate.validateRadio();

        if (isValid) {
            _showInlineError(false);
            $inputs.removeClass("invalid").addClass("valid");
        } else {
            _showInlineError(true);
            $inputs.removeClass("valid").addClass("invalid");
        }

        _quoterValid.panel2.typeChosen = isValid;
    }

    // Panel 3

    function _applyKnockOut(value, async) {
        if (aaalife.utils.prevalidate.isSameKOStatus(value)) {
            return;
        }
        var attrData = transformData("itc", "");
        attrData = appendData(attrData, "ko", value);
        var groupData = transformData("attr", attrData);
        sendData(groupData, async);
    }

    // Helper Functions --------------------------------------------------

    /**
     * _currentSlideIndex
     *
     * @returns {*|jQuery}
     * @private
     */
    function _currentSlideIndex() {
        var currentSlideEle = $(".panel-container").children(".active");
        var currentSlide = $(currentSlideEle).index(); // For currentSlide
        // Number
        return currentSlide;
    }

    /**
     * _populateUserValuesIfSaved
     *
     * @private
     */
    function _populateUserValuesIfSaved() {
        var user = _getUserData();
        var quote = _getQuoteData();
        aaalife.data.user = user;
        aaalife.data.quote = quote;

        if (user.zip !== "") {
            $(".zipNumeric").val(user.zip);
            $("#zip").val(user.zip).trigger("change");
        }

        if (user.gender !== "") {
            $("#gender").val(user.gender).trigger("change");
        }

        _populateMonth(user);

        _populateDay(user);

        if (user.dobYear !== "") {
            $("#year").val(user.dobYear).trigger("change");
        }

        if (user.isMember === "true") {
            $("#isMemberYes").click();
        } else if (user.isMember === "false") {
            $("#isMemberNo").click();
        }
        if (user.hasPolicy === "Yes") {
            $("#yesExistingPolicy").click();
        } else if (user.hasPolicy === "No") {
            $("#noExistingPolicy").click();
        }

        if (user.email) {
            $("#contact_email").val(user.email).trigger("change");
            $("#emailAddress").val(user.email);
        }

        if (quote.type) {
            $('[value="' + aaalife.data.quote.type + '"]').click();
        }

        var itc = $("#quoteForm").data("panel-two");
        var source = "0";
        $("#giwl-panel1-next").data("itc", itc);
        $("#giwl-panel1-next").data("source", source);

        $("#panel3-back").data("itc", itc);
        $("#panel3-back").data("source", source);

        _setInitialDisplayState();
    }

    function _populateDay(user) {
        if (user.dobDay !== "") {
            $("#day").val(user.dobDay).trigger("change");
            $("#daySelectBoxItText").text(user.dobDay);
            $("#daySelectBoxItText").attr("data-val", user.dobDay);
            $("#daySelectBoxItText").attr("aria-label", user.dobDay);
        }
    }

    function _populateMonth(user) {
        if (user.dobMonth !== "") {
            $("#month").val(user.dobMonth).trigger("change");
            $("#monthSelectBoxItText").text(user.dobMonth);
            $("#monthSelectBoxItText").attr("data-val", user.dobMonth);
            $("#monthSelectBoxItText").attr("aria-label", user.dobMonth);
        }
    }

    function _setInsuranceTypeToTraditional() {
        var quote = _getQuoteData();
        aaalife.data.quote = quote;

        aaalife.data.quote.type = "traditional_term";

        browserStorage.setObject("quote", aaalife.data.quote);

        $('[value="traditional_term"]').click();
    }

    function _setInsuranceTypeToExpress() {
        var quote = _getQuoteData();
        aaalife.data.quote = quote;

        aaalife.data.quote.type = "express_term";

        browserStorage.setObject("quote", aaalife.data.quote);

        $('[value="express_term"]').click();
    }

    function _hasClass(element, cls) {
        return (" " + element.className + " ").indexOf(" " + cls + " ") > -1;
    }

    function _seeQuoteClicked() {
        var i;
        var numPanels = 3;
        var topOfResultsPanel;
        var replacementPolicyFieldFilled;

        // validate all panels
        for (i = 0; i < numPanels; i++) {
            _validatePanel(i);
        }

        if ($('form[name="combinedQuoteForm"]').length > 0) {
            $("#quoteForm").append('<input type="hidden" name="insurance_type" value="' + aaalife.data.quote.type + '">');
        }

        if ($('form[name="combinedQuoteForm"]').length > 0 || $('form[name="panelsQuoteFormTraditional"]').length > 0) {
            if (aaalife.data.quote.type === "traditional_term") {
                $("#quoteForm").data("special-action", "sf-p");
            }
        }

        if (_allPanelsValid()) {
            _saveValues();
            _showInlineErrorForQuoteForm(false);
            if (aaalife.fromServer.urlStrings.pageUrl.indexOf("homepage") !== -1) {
                aaalife.data.quote.origin = "/";
            } else {
                aaalife.data.quote.origin = aaalife.fromServer.urlStrings.pageUrl;
            }

            if (
                $('form[name="panelsQuoteForm"]').length > 0 ||
                $('form[name="panelsQuoteFormTraditional"]').length > 0 ||
                $('form[name="panelsQuoteFormExpress"]').length > 0
            ) {
                aaalife.data.quote.panelFlag = "true";
            }
            aaalife.data.quote.results = "";
            browserStorage.setObject("quote", aaalife.data.quote);

            var itc = $("#seeQuote").data("itc");
            if (itc != "") {
                $("#quoteForm").append('<input type="hidden" name="interactionCode" value="' + itc + '">');
            }

            if (typeof aaalife.fromServer.emailSource != "undefined") {
                $("#quoteForm").append(
                    '<input type="hidden" name="attr-source" value="' + aaalife.fromServer.emailSource + '">',
                );
            }

            $("#quoteForm").submit();
        } else {
            replacementPolicyFieldFilled = _hasValue.call(_quoterValid.panel3Fields.existingPolicyField);
            if (
                replacementPolicyFieldFilled &&
                !_quoterValid.panel3.existingPolicy &&
                _zipRestrictions.replacementPolicyNotOffered
            ) {
                _showErrorModal(aaalife.fromServer.errorModalsData.existingPolicy, true, $("#zip").val());
            }

            _showInlineErrorForQuoteForm(true);

            if (isPanelBMIInvalidWithData()) {
                _showErrorModal(aaalife.fromServer.errorModalsData.noQuoteAvailable, true, $("#zip").val());
            }

            // show errors in all panels
            for (i = 1; i <= numPanels; i++) {
                _highlightErrors(i);
            }

            var itc = $("#seeQuote").data("itc");
            $("#seeQuote").data("itc", "");
            var formData = collectFormData($("#quoteForm"), $("#seeQuote").data());
            if (
                !_quoterValid.panel3.validBMI &&
                $("#year").val() !== "" &&
                $("#feet").val() !== "" &&
                $("#inches").val() !== "" &&
                $("#weight").val() !== ""
            ) {
                formData = appendData(formData, "ko", "y");
            }
            sendData(formData, false);
            $("#seeQuote").data("itc", itc);

            if (isPanelBMIInvalidWithData()) {
                if ($(".combinedForm-quoteForm").length > 0) var evt = "TQLKO";
                // Event for combined forms
                else var evt = "TQSKO2"; // Event for panel forms
                sendEvent(evt);
            }
        }
    }

    function isPanelBMIInvalidWithData() {
        if (
            !_quoterValid.panel3.validBMI &&
            $("#year").val() !== "" &&
            $("#feet").val() !== "" &&
            $("#inches").val() !== "" &&
            $("#weight").val() !== ""
        ) {
            return true;
        }
        return false;
    }

    // Slide Panels -----------------------------------------------------

    /**
     * _getCurrentPanel
     *
     * @returns {string}
     * @private
     */
    function _getCurrentPanel() {
        var currentPanelToCheck = "panel" + (_currentSlideIndex() + 1);
        return currentPanelToCheck;
    }

    function giwlPass(response) {
        if (typeof response !== "undefined") {
            $.each(response.dataList.sort().reverse(), function (index, value) {
                var rowName = "quoteRadio";
                var rowId = rowName + index;
                const coverageAmountFormatted = coverageFormatter.format(value.baseAmount);
                const monthlyPaymentFormatted = monthlyFormatter.format(value.monthlyPremium);
                const toEnglishNumber = (number) =>
                    ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"][number];
                const dataLayerEventName = "GIWLsecondPanelOption" + toEnglishNumber(index + 1);
                const newInputValue = encodeURIComponent(JSON.stringify(value));
                const newInput = `<input type="radio" name="${rowName}" id="${rowId}" value="${newInputValue}" data-datalayerevent="${dataLayerEventName}" />`;
                const newLabel = `<label for="${rowId}"><span><span></span></span>${coverageAmountFormatted}</label>`;
                const newElement = $(`<tr><td>${newInput}${newLabel}</td><td>${monthlyPaymentFormatted}</td></tr>`);

                newElement.change(function () {
                    dataLayer.push({
                        event: dataLayerEventName,
                        quote: {
                            monthlyPayment: monthlyPaymentFormatted,
                            coverageAmount: coverageAmountFormatted,
                        },
                    });
                });
                $(".displayCovOpts").append(newElement);
            });

            $(".table tbody tr").click(function (event) {
                //Enable whole row to be clickable
                if (event.target.type !== "radio") {
                    $(":radio", this).trigger("click");
                }

                $("tr").removeClass("selected"); //remove 'selected' from all rows
                $(this).closest("tr").addClass("selected"); //'select' current row
            });
        }
    }

    /**
     * _nextGIWLClicked
     *
     * @private
     */
    async function _nextGIWLClicked() {
        var isValid;
        var currentPanel = _getCurrentPanel();

        // ensure current panel is validated
        _quoterValid = _validatePanel();

        // are all validation points valid?
        isValid = Object.keys(_quoterValid[currentPanel]).every(function (key) {
            return _quoterValid[currentPanel][key];
        });

        var form = $(this).closest("form");
        var button = $(this).closest("button");
        if (isValid) {
            _saveValues();
            _showInlineErrorForQuoteForm(false);

            var formData = collectFormData(form, button.data());
            if (aaalife.data.quote.type != "") {
                var currentData = formData["current"];
                currentData["insurance_type"] = aaalife.data.quote.type;
                formData["current"] = currentData;
            }

            if (
                aaalife.data.quote.type === "traditional_term" &&
                ((aaalife.data.quote.type && aaalife.fromServer.quoteType) || _zipRestrictions.expressTermNotOffered)
            ) {
                $("#giwl-panel1-next").data("special-action", "sf-p");
            }

            const responses = await Promise.all([
                sendReceiveData(collectGIWLFormData(currentData), "/services/quote-services/giwl-quote", true),
                sendDataAsync(formData),
            ]);
            giwlPass(responses[0]);

            browserStorage.setObject("user", aaalife.data.user);

            _panelSlide("next");

            //UPDATE THE TITLE
            $("h3.imgFormCmpnt-heading").text(coverageOptionsTitle);
        } else {
            if (_zipRestrictions.allTermNotOffered) {
                _showErrorModal(aaalife.fromServer.errorModalsData.allTermNotOffered);
            }
            _validateAge("showRed");
            validateReplacementPolicy();
            _showInlineErrorForQuoteForm(true);
            _highlightErrors();
            var itc = button.data("itc");
            button.data("itc", "");
            var formData = collectFormData(form, button.data());
            sendData(formData, false);
            button.data("itc", itc);
        }
    }

    function validateReplacementPolicy() {
        var replacePolicy = $("input[name='policy_type']:checked").val();
        if (replacePolicy == "Yes") {
            $("div.showIfYesReplace").show();
            _showErrorModal(aaalife.fromServer.errorModalsData.allTermNotOffered, true, _zipRestrictions.zip);
            _showInlineErrorForQuoteForm(true);
            _highlightInvalidField(false, $('[name="policy_type"]'));
            _quoterValid.panel1.policyReplacement = false;
            _applyKnockOut("y", false);
            sendEvent("GIWLKO3");
        } else {
            $("div.showIfYesReplace").hide();
            _showInlineErrorForQuoteForm(false);
            _highlightInvalidField(true, $('[name="policy_type"]'));
        }
    }

    function _enrollNowGIWLClicked() {
        var $form = $(this).closest("form");

        var selectedRadioButtons = Array.from(document.getElementsByName("quoteRadio")).filter(function (radioButton) {
            return radioButton.checked;
        });

        if (selectedRadioButtons.length !== 1) {
            _showInlineErrorForQuoteForm(true);
            _highlightErrors();
            return;
        }

        var quote = JSON.parse(decodeURIComponent(selectedRadioButtons[0].value));

        var quoteStorageData = {
            type: quote.basePlan,
            term: 10,
            premium: quote.monthlyPremium,
            coverage: quote.baseAmount,
        };

        let aggregatedQuoteData = {
            premiumAmount: quote.monthlyPremium.toString() + ".00",
            coverageAmount: quote.baseAmount.toString(),
            paymentFrequencyMode: "M",
        };

        browserStorage.setObject("quote", quoteStorageData);

        $.when(sendReceiveData({ current: aggregatedQuoteData }, aaalife.ctx + "restservices/aggregate", false)).then(
            function () {
                var user = _getUserData();
                var pageParams = $.extend({}, retrieveUrlParameters() || {});

                var hostUrl = (function () {
                    var hostWithPort = window.location.host.toLowerCase();
                    var hostName = window.location.hostname
                        .toLowerCase()
                        .replace(/^www\./, "")
                        .replace(/^giwl\./, "");

                    if (hostWithPort === "localhost:8443") {
                        return "env04.tst.aaalife.com";
                    }

                    var envMatch = hostName.match(/^(tst|dev)aaa(0[1-4])\.aaalife\.com$/);

                    if (envMatch) {
                        return "env" + envMatch[2] + "." + envMatch[1] + ".aaalife.com";
                    }

                    if (hostName === "pre.aaalife.com") {
                        return "pre.dev.aaalife.com";
                    }

                    return hostName;
                })();

                // These params must ONLY come from form/user data, never from the page URL
                var reservedParams = ["gender", "dob", "zipCode", "state", "coverage", "premium", "email", "isMember"];

                reservedParams.forEach(function (key) {
                    delete pageParams[key];
                });

                var savedSessionIDGIWL = document.getElementById("sessionID").value;

                var genderRaw = ($("#gender").val() || user.gender || "").toString().toLowerCase();
                var gender = genderRaw;
                if (genderRaw === "m") gender = "male";
                if (genderRaw === "f") gender = "female";

                var dobYear = $("#year").val() || user.dobYear || "";
                var dobMonthRaw = $("#month").val() || user.dobMonth || "";
                var dobDayRaw = $("#day").val() || user.dobDay || "";
                var dobMonth = dobMonthRaw ? String(dobMonthRaw).padStart(2, "0") : "";
                var dobDay = dobDayRaw ? String(dobDayRaw).padStart(2, "0") : "";
                var dob = dobYear && dobMonth && dobDay ? dobYear + "-" + dobMonth + "-" + dobDay : "";

                var isMember = $("input:radio[name=isMember]:checked").val();
                if (typeof isMember === "undefined" || isMember === "") {
                    isMember = user.isMember;
                }

                var formParams = {};

                if (gender) formParams.gender = gender;
                if (dob) formParams.dob = dob;
                if ($("#zip").val() || user.zip) formParams.zipCode = $("#zip").val() || user.zip;
                if (user.state) formParams.state = user.state;
                if (quote.baseAmount) formParams.coverage = quote.baseAmount;
                if (quote.monthlyPremium) formParams.premium = quote.monthlyPremium;
                if ($("#contact_email").val() || user.email) formParams.email = $("#contact_email").val() || user.email;
                if (typeof isMember !== "undefined" && isMember !== "") formParams.isMember = isMember;
                if (savedSessionIDGIWL) formParams.sessionId = savedSessionIDGIWL;

                // Keep existing page params like ?cc=123, but form params win
                var redirectParams = $.extend({}, pageParams, formParams);

                var redirectUrl = "https://giwl." + hostUrl + "/application/contact";
                var queryString = $.param(redirectParams);
                if (queryString) {
                    redirectUrl += "?" + queryString;
                }

                // console.log("Redirecting to: " + redirectUrl); // Utalized for testing
                location.href = redirectUrl;
            },
        );
    }

    /**
     * _nextClicked
     *
     * @private
     */
    function _nextClicked() {
        var isValid;
        var currentPanel = _getCurrentPanel();

        // ensure current panel is validated
        _quoterValid = _validatePanel();

        // are all validation points valid?
        isValid = Object.keys(_quoterValid[currentPanel]).every(function (key) {
            return _quoterValid[currentPanel][key];
        });

        var form = $(this).closest("form");
        var button = $(this).closest("button");
        if (isValid) {
            _saveValues();
            _showInlineErrorForQuoteForm(false);

            var formData = collectFormData(form, button.data());
            if (aaalife.data.quote.type != "") {
                var currentData = formData["current"];
                currentData["insurance_type"] = aaalife.data.quote.type;
                formData["current"] = currentData;
            }

            if (
                aaalife.data.quote.type === "traditional_term" &&
                ((aaalife.data.quote.type && aaalife.fromServer.quoteType) || _zipRestrictions.expressTermNotOffered)
            ) {
                $("#giwl-panel1-next").data("special-action", "sf-p");
            }

            sendReceiveData(formData, "/services/quote-services/giwl-quote", true);

            _panelSlide("next");
        } else {
            if (_zipRestrictions.allTermNotOffered) {
                _showErrorModal(aaalife.fromServer.errorModalsData.allTermNotOffered);
            }

            _showInlineErrorForQuoteForm(true);
            _highlightErrors();
            var itc = button.data("itc");
            button.data("itc", "");
            var formData = collectFormData(form, button.data());
            sendReceiveData(formData, "/services/quote-services/giwl-quote", true);
            button.data("itc", itc);
        }
    }

    /**
     * _backClicked
     *
     * @private
     */
    function _backClicked() {
        var button = $(this).closest("button");
        var data = transformData("itc", button.data("itc"));
        var groupData = transformData("attr", data);
        sendData(groupData, false);
        _showInlineErrorForQuoteForm(false);
        _panelSlide("back");
    }

    /**
     * _panelSlide
     *
     * @param type
     *            {string=}
     * @returns {boolean}
     * @private
     */
    function _panelSlide(type) {
        var panelContainerChildren = $(".panel-container").children();
        var currentSlide = _currentSlideIndex();
        var toBeCurrentSlide;
        var insurance_type;
        var slideLeft;
        var left;
        var i;

        // Wide format: no sliding
        if (aaalife.fromServer.quoteSize !== "qfWide") {
            if (type == "back") {
                toBeCurrentSlide = currentSlide - 1;

                if (
                    toBeCurrentSlide === 1 &&
                    ((aaalife.data.quote.type && aaalife.fromServer.quoteType) || _zipRestrictions.expressTermNotOffered)
                ) {
                    // if there is already a type, skip the interstitial
                    toBeCurrentSlide = 0;
                }
                if (toBeCurrentSlide === 0) {
                    if (!aaalife.fromServer.quoteType) {
                        aaalife.data.quote.type = "";
                    }
                    $(".quoteForm-redCircleBlock").removeClass("hide");
                    $("#item2").add($("#item3")).removeClass("hide");
                    $("#item1").removeClass("expand");
                }
            } else if (type == "next") {
                toBeCurrentSlide = currentSlide + 1;

                if (toBeCurrentSlide > 0) {
                    $(".quoteForm-redCircleBlock").addClass("hide");
                    $("#item2").add($("#item3")).addClass("hide");
                    $("#item1").addClass("expand");
                }

                /* ====ExpressTerm and TraditionalTerm panel logic=== */
                if (
                    toBeCurrentSlide === 1 &&
                    ((aaalife.data.quote.type && aaalife.fromServer.quoteType) || _zipRestrictions.expressTermNotOffered)
                ) {
                    // if there is already a type, skip the interstitial
                    toBeCurrentSlide = 2;
                    insurance_type = aaalife.data.quote.type;
                }

                _setCoverageAndTermOptions(insurance_type, false);
            } else {
                toBeCurrentSlide = currentSlide;
            }

            /* = Existing policy error pop up= */
            if (toBeCurrentSlide === 3) {
                toBeCurrentSlide = currentSlide;
            }

            slideLeft = $("body").width() > 768 ? 350 : $("body").width();

            $("#quoteForm .panel-container").children().width($("#quoteForm").width());
            for (i = 0; i < panelContainerChildren.length; i++) {
                left = i * slideLeft - toBeCurrentSlide * slideLeft;
                if (toBeCurrentSlide == i) {
                    $(panelContainerChildren[i]).addClass("active").removeClass("hide");
                } else {
                    $(panelContainerChildren[i]).removeClass("active").addClass("hide");
                }

                $(panelContainerChildren[i]).css("left", left + "px");
            }

            var $activePanel = $("#quoteForm .panel-container .active");
            var $invalidFields = $activePanel.find(".invalid");
            if ($invalidFields.length > 0) {
                _showInlineError(true);
            } else {
                _showInlineError(false);
            }

            // scroll to the top of the form, if needed
            if ($("#quoteForm").length > 0) {
                _repositionWindow($("#quoteForm"));
            } else if ($("#expressTermForm").length > 0) {
                _repositionWindow($("#expressTermForm"));
            }
        }

        //Look at this
        if ($activePanel) {
            var evt = $activePanel.data("event");
            if (evt) sendEvent(evt);
        }

        // on click of next button, apply bottom blue border class as needed
        if ($("#quoteForm").length) {
            $("#accordion").toggleClass("contentBorder", toBeCurrentSlide > 0);
        }
    }

    // Modify Display
    // -------------------------------------------------------------

    function _repositionWindow(formToOffset) {
        var topOfForm = formToOffset.offset().top - 80;
        if (window.scrollY > topOfForm) {
            window.scrollTo(0, topOfForm);
        }
    }

    /**
     * _markDirty
     *
     * @private
     */
    function _markDirty() {
        $(this).removeClass("pristine").addClass("dirty");
    }

    /**
     * _highlightInvalidField
     *
     * @param isValid
     * @param $argElement
     * @private
     */
    function _highlightInvalidField(isValid, $argElement) {
        var $element = typeof $argElement !== "undefined" ? $argElement : $(this);

        if (isValid) {
            _showInlineError(false);
            $element.removeClass("invalid").addClass("valid");
        } else {
            _showInlineError(true);
            $element.removeClass("valid").addClass("invalid");
        }
    }

    function _showErrorModal(text, shouldUseDynamicPhone, zip) {
        $(".error-modal .error-modal-heading").html(text.heading);
        $(".error-modal .error-desc").html(text.desc);
        $(".error-modal .error-secondarydesc").html(text.desc2);

        if (shouldUseDynamicPhone) {
            var params = retrieveUrlParameters();

            let cmp = params.cmp;
            var lead = params.lead;
            getClubAndCampaignProfile(zip, cmp, lead)
                .then(updateDynamicPhone)
                .catch((error) => console.error("Error updating phone", error));
        }

        _inlineModal.open();
    }

    /**
     * _showInlineError
     *
     * @param show
     * @private
     */
    function _showInlineError(show) {
        $(".inlineValidation").toggleClass("show", show);
    }

    /**
     * _showInlineError
     *
     * @param show
     * @private
     */
    function _showInlineErrorForQuoteForm(show) {
        $(".inlineValidation-quote").toggleClass("show", show);
    }

    /**
     * _highlightErrors
     *
     * @param panel
     * @private
     */
    function _highlightErrors(panel) {
        var currentPanel = panel || _getCurrentPanel();
        if (panel) {
            currentPanel = "panel" + currentPanel;
        }

        Object.keys(_quoterValid[currentPanel]).forEach(function (key) {
            _quoterValid[currentPanel + "Fields"][key + "Field"]
                .toggleClass("valid", _quoterValid[currentPanel][key])
                .toggleClass("invalid", !_quoterValid[currentPanel][key]);
        });
    }

    /**
     * _setInitialDisplayState
     *
     * @private
     */
    function _setInitialDisplayState() {
        if ($(".zipNumeric").val()) {
            _validateZip.call($(".zipNumeric")[0]);
        }
    }

    /**
     * _populateDropdowns
     *
     * @param dropdown
     * @param startVal
     * @param maxVal
     * @param dirMod
     * @private
     */
    function _populateDropdowns(dropdown, startVal, maxVal, dirMod, doubledigits) {
        var i;
        for (i = startVal; startVal > maxVal ? i >= maxVal : i <= maxVal; i += dirMod) {
            if ($("#expressTermForm").length > 0) {
                if (i < 10) {
                    dropdown.append(
                        $("<option></option>")
                            .val("0" + i)
                            .html("0" + i),
                    );
                } else {
                    dropdown.append($("<option></option>").val(i).html(i));
                }
            } else {
                dropdown.append($("<option></option>").val(i).html(i));
            }
        }
    }

    /**
     * _populateDaysDropdown
     *
     * @private
     */
    function _populateDaysDropdown() {
        var month = $("#month").val() * 1 || new Date().getMonth();
        var year = $("#year").val() * 1 || 2008; //in the case year hasn't been entered yet, use a year that allows Feb 29 by default
        var $day = $("#day");
        var oldDay = $day.val();
        var numDays = new Date(year, month, 0).getDate();

        $day.find("option").not(":first-child").remove();

        _populateDropdowns($day, 1, numDays, 1);

        if (oldDay && oldDay <= numDays) {
            $day.val(oldDay);
        } else if ($day.hasClass("dirty") || $day.hasClass("pristine")) {
            $day.val("");
            if ($day.hasClass("dirty") && oldDay) {
                $day.removeClass("valid").addClass("invalid");
            }
            _quoterValid.panel1.age = false;
        }
    }

    /**
     * _setCoverageAndTermOptions
     *
     * @param insurance_type
     * @private
     */
    function _setCoverageAndTermOptions(insurance_type, isInitilize) {
        const age = ageLastBirthday(createDate($("#year").val(), $("#month").val(), $("#day").val()), new Date());
        var expressCoverages = _getExpressCoverages(age);
        var traditionalCoverages = _getTraditionalCoverages();
        var termLengthOptions = _getTermLengthOptions();
        var $coverageAmount = $("#coverageAmount");
        var orgCoverageAmount = $coverageAmount.val();
        var $termLength = $("#termLength");
        var orgTermLength = $termLength.val();
        var quote = _getQuoteData();
        var termLengths;
        var savedCoverageAmount;
        var savedTermLength;
        var calcCoverageAmount;

        if (!isInitilize) {
            if (orgTermLength === "") {
                savedTermLength = "";
            } else {
                savedTermLength = quote.term;
            }
        } else {
            savedTermLength = quote.term;
        }

        if (!isInitilize) {
            savedCoverageAmount = "";
        } else {
            calcCoverageAmount = _determineCoverageAmount(quote, insurance_type, expressCoverages, traditionalCoverages);
            savedCoverageAmount = calcCoverageAmount;
        }

        $(".panel-panel3").removeClass("express_term traditional_term").addClass(insurance_type);

        if (insurance_type === "express_term") {
            $coverageAmount.find("option").remove().end().append('<option value="" selected hidden>Select</option>');
            expressCoverages.forEach(_createCoveragesOption);
        }
        if (insurance_type === "traditional_term") {
            $coverageAmount.find("option").remove().end();
            traditionalCoverages.forEach(_createCoveragesOption);
            if (savedCoverageAmount == "") {
                $coverageAmount.val("500,000");
            }
        }

        if (
            orgCoverageAmount &&
            $coverageAmount.find('option[value="' + orgCoverageAmount + '"]').length > 0 &&
            !$coverageAmount.val()
        ) {
            $coverageAmount.val(orgCoverageAmount);
        }

        // Get appropriate set by age
        termLengths = termLengthOptions[Object.keys(termLengthOptions).find(_findAgeGrouping)];

        // RULE (as of May 2016) - If user enters age >50 and Nicotine = Yes,
        // remove 30 year term from Term Length dropdown
        if (_disallowThirty && termLengths.indexOf(30) !== -1) {
            termLengths.splice(termLengths.indexOf(30), 1);
        }
        $termLength.find("option").remove().end().append('<option value="" selected hidden>Select</option>');
        termLengths.forEach(_createTermLengthOption);

        if (orgTermLength && $termLength.find('option[value="' + orgTermLength + '"]').length > 0 && !$termLength.val()) {
            $termLength.val(orgTermLength);
        }

        function _determineCoverageAmount(quote, insurance_type, expressCoverages, traditionalCoverages) {
            var estimatedNeed = quote.estimatedNeed && quote.estimatedNeed.replace(/,/g, "") * 1;
            var coverageArray = [];
            var amount = quote.coverage;
            var arrayValue;
            var found;
            var i;

            if (estimatedNeed && insurance_type) {
                if (insurance_type === "express_term") {
                    coverageArray = expressCoverages;
                } else if (insurance_type === "traditional_term") {
                    coverageArray = traditionalCoverages;
                }

                found = false;
                for (i = 0; i < coverageArray.length; i++) {
                    arrayValue = coverageArray[i].replace(/,/g, "") * 1;
                    if (arrayValue >= estimatedNeed) {
                        amount = coverageArray[i];
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    amount = coverageArray[coverageArray.length - 1];
                }

                // Clear out estimateNeed after first use, so it doesn't affect
                // later calculations
                quote.estimatedNeed = "";
                aaalife.data.quote.estimatedNeed = quote.estimatedNeed;
                browserStorage.setObject("quote", aaalife.data.quote);
            }
            return amount;
        }

        // Rules (express_term) (as of NOVEMBER 2016)
        // AGES 18-59 - Include '25,000', '30,000', '35,000', '40,000',
        // '45,000', '50,000', '60,000', '70,000', '80,000', '90,000',
        // '100,000', '125,000', '150,000', '175,000', '200,000', '225,000',
        // '250,000' in drop down
        // AGES 60-64 - Include '25,000', '30,000', '35,000', '40,000',
        // '45,000', '50,000', '55,000', '60,000', '65,000', '70,000', '75,000',
        // '80,000', '85,000', '90,000', '95,000', '100,000' in drop down
        // AGES 65-69 - Include '25,000', '30,000', '35,000', '40,000',
        // '45,000', '50,000'
        // AGES 70-75 - Include '25,000' in drop down
        /**
         * _getExpressCoverages
         *
         * @params {number} age
         * @returns {Array}
         * @private
         */
        function _getExpressCoverages(age) {
            var expressCoverageOptions = {
                "0-59": [
                    "25,000",
                    "30,000",
                    "35,000",
                    "40,000",
                    "45,000",
                    "50,000",
                    "60,000",
                    "70,000",
                    "80,000",
                    "90,000",
                    "100,000",
                    "125,000",
                    "150,000",
                    "175,000",
                    "200,000",
                    "225,000",
                    "250,000",
                ],
                "60-64": [
                    "25,000",
                    "30,000",
                    "35,000",
                    "40,000",
                    "45,000",
                    "50,000",
                    "55,000",
                    "60,000",
                    "65,000",
                    "70,000",
                    "75,000",
                    "80,000",
                    "85,000",
                    "90,000",
                    "95,000",
                    "100,000",
                ],
                "65-69": ["25,000", "30,000", "35,000", "40,000", "45,000", "50,000"],
                "70-125": ["25,000"],
            };

            // Get appropriate set by age
            return expressCoverageOptions[Object.keys(expressCoverageOptions).find(_findAgeGrouping)];
        }

        /**
         * _findAgeGrouping
         *
         * @param key
         * @returns {*}
         * @private
         */
        function _findAgeGrouping(key) {
            var min = key.split("-")[0] * 1;
            var max = key.split("-")[1] * 1;

            if (age >= min && age <= max) {
                return key;
            }
            return false;
        }

        /**
         * _createExpressCoveragesOption
         *
         * @param coverageAmount
         * @private
         */
        function _createCoveragesOption(coverageAmount) {
            var selectedString = "";
            if (coverageAmount == savedCoverageAmount) {
                selectedString = ' selected="selected"';
            }
            $coverageAmount.append(
                "<option" + selectedString + ' value="' + coverageAmount + '">$' + coverageAmount + "</option>",
            );
        }

        /**
         * _createTraditionalCoveragesOption
         *
         * @param coverageAmount
         * @private
         */
        function _createTraditionalCoveragesOption(coverageAmount) {
            var selectedString = "";
            if (coverageAmount == savedCoverageAmount) {
                selectedString = ' selected="selected"';
            }
            $coverageAmount.append(
                "<option" + selectedString + ' value="' + coverageAmount + '">$' + coverageAmount + "</option>",
            );
        }

        /**
         * _createTermLengthOption
         *
         * @param termLength
         * @private
         */
        function _createTermLengthOption(termLength) {
            var selectedString = "";
            if (termLength == savedTermLength) {
                selectedString = ' selected="selected"';
            }
            $termLength.append("<option" + selectedString + ' value="' + termLength + '">' + termLength + " Years</option>");
        }
    }

    // Rules (traditional_term) (as of January 2025)
    // ALWAYS SHOW: $50,000 $100,000, $150,000, $200,000, $250,000, $300,000,
    // $350,000, $400,000, $450,000, $500,000, $550,000,
    // $600,000, $650,000, $700,000, $750,000, $800,000,
    // $850,000, $900,000, $950,000, $1,000,000, and $2,000,000
    /**
     * _getTraditionalCoverages
     *
     * @returns {string[]}
     * @private
     */
    function _getTraditionalCoverages() {
        return [
            "50,000",
            "100,000",
            "150,000",
            "200,000",
            "250,000",
            "300,000",
            "350,000",
            "400,000",
            "450,000",
            "500,000",
            "550,000",
            "600,000",
            "650,000",
            "700,000",
            "750,000",
            "800,000",
            "850,000",
            "900,000",
            "950,000",
            "1,000,000",
            "2,000,000",
        ];
    }

    // Rules (both) (as of May 2016)
    // Ages 18-55 show 10, 15, 20, 25, 30
    // Ages 55-60 show 10, 15, 20, 25
    // Ages 60-65 show 10, 15, 20
    // Ages 65-70 show 10, 15
    // Ages 70-75 show 10
    /**
     * _getTermLengthOptions
     *
     * @returns {{0-55: number[], 55-60: number[], 60-65: number[], 65-70:
     *          number[], 70-125: number[]}}
     * @private
     */
    function _getTermLengthOptions() {
        return {
            "0-55": [10, 15, 20, 25, 30],
            "55-60": [10, 15, 20, 25],
            "60-65": [10, 15, 20],
            "65-70": [10, 15],
            "70-125": [10],
        };
    }
}
